<template>
  <button @click="$router.go(-1)" class="link-back">&larr; Back</button>
  <h2>{{ participant.lastName }}, {{ participant.firstName }}</h2>
  <p>Gate: {{ participant.gate }}</p>
  <p>Shares: {{ participant.shareCount }}</p>
  <p>Single Week Time: {{ formatTurnLengths(participant.turnLength.single) }}</p>
  <p>Double Week Time: {{ formatTurnLengths(participant.turnLength.double) }}</p>
  <br>
  <table>
    <thead>
      <td class="start">Start</td>
      <td class="end">End</td>
    </thead>
    <tbody>
      <tr v-for="entry in participant.participantCalendar" :key="entry.label">
        <td>{{ entry.start }}</td>
        <td>{{ entry.end }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  inject: ['participantData'],
  data() {
    return {
      participant: {}
    }
  },
  methods: {
    formatTurnLengths(time) {
      const totalMinutes = time;
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return hours + "hr " + minutes + "min";
    }
  },
  created() {
    const theParticipant = this.$route.params.participantID;
    const singleData = this.participantData.find(single => single.id === theParticipant);
    this.participant = singleData;
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border: 0;
  border-collapse: collapse;
} 

table td {
  border: 1px solid #ccc;
  margin: 0;
  padding: 7px;
  text-align: center;
}

table thead td {
  font-weight: 700;
}

.start {
  background-color: var(--green-100);
  color: var(--white);
}

.end {
  background-color: var(--red-100);
  color: var(--white);
}
</style>